import { Product } from '../types';

// ============================================
// SPECIAL HOLDERS & RELAY COMBINATIONS
// ============================================

// SPECIAL UNIVERSAL HOLDERS - ASHOK LEYLAND & TATA NEW MODEL
export const specialHolderNewModelProducts: Product[] = [
  {
    id: "special-holder-al-new-model-2p-f",
    name: "Ashok Leyland New Model 2 Pole Female - Special Holder",
    slug: "special-holder-al-new-model-2-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Ashok Leyland new model 2 pole female special holder with special wire. 9 inch long.",
    partNumber: "SH3100201",
    image: "/products/universal-holders/universal/SH3100201.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "2-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-holder-al-new-model-3p-f",
    name: "Ashok Leyland New Model 3 Pole Female - Special Holder",
    slug: "special-holder-al-new-model-3-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Ashok Leyland new model 3 pole female special holder with special wire. 9 inch long.",
    partNumber: "SH3100301",
    image: "/products/universal-holders/universal/SH3100301.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "3-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-holder-tata-combination-4p-f",
    name: "Tata Combination Set 4 Pole Female - Special Holder",
    slug: "special-holder-tata-combination-4-pole-female",
    category: "Special Holders",
    subcategory: "Combination Set Holders",
    description: "Tata combination set 4 pole female special holder with special wire. 9 inch long.",
    partNumber: "SH3100401",
    image: "/products/universal-holders/universal/SH3100401.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "Tata Combination Set",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "4-pole", "tata", "combination", "female"],
    applications: ["Tata Combination Set"],
  },
  {
    id: "special-holder-tata-combination-6p-f",
    name: "Tata Combination Set 6 Pole Female - Special Holder",
    slug: "special-holder-tata-combination-6-pole-female",
    category: "Special Holders",
    subcategory: "Combination Set Holders",
    description: "Tata combination set 6 pole female special holder with special wire. 9 inch long.",
    partNumber: "SH3100601",
    image: "/products/universal-holders/universal/SH3100601.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Tata Combination Set",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "6-pole", "tata", "combination", "female"],
    applications: ["Tata Combination Set"],
  },
  {
    id: "special-holder-tata-new-model-8p-f",
    name: "Tata New Model 8 Pole Female - Special Holder",
    slug: "special-holder-tata-new-model-8-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Tata new model 8 pole female special holder with special wire. 9 inch long.",
    partNumber: "SH3100801",
    image: "/products/universal-holders/universal/SH3100801.jpg",
    featured: true,
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Female",
      "Compatible": "Tata New Model",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "8-pole", "tata", "new-model", "female"],
    applications: ["Tata New Model"],
  },
  {
    id: "special-holder-tata-new-model-10p-f",
    name: "Tata New Model 10 Pole Female - Special Holder",
    slug: "special-holder-tata-new-model-10-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Tata new model 10 pole female special holder with 4mm deluxe wire. 9 inch long.",
    partNumber: "SH3101001",
    image: "/products/universal-holders/universal/SH3101001.jpg",
    specifications: {
      "Poles": "10 Pole",
      "Gender": "Female",
      "Compatible": "Tata New Model",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "10-pole", "tata", "new-model", "female"],
    applications: ["Tata New Model"],
  },
  {
    id: "special-holder-al-new-model-12p-f",
    name: "Ashok Leyland New Model 12 Pole Female - Special Holder",
    slug: "special-holder-al-new-model-12-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Ashok Leyland new model 12 pole female special holder with 4mm deluxe wire. 9 inch long.",
    partNumber: "SH3101201",
    image: "/products/universal-holders/universal/SH3101201.jpg",
    featured: true,
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "12-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-holder-al-new-model-14p-f",
    name: "Ashok Leyland New Model 14 Pole Female - Special Holder",
    slug: "special-holder-al-new-model-14-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Ashok Leyland new model 14 pole female special holder with 4mm deluxe wire. 9 inch long.",
    partNumber: "SH3101401",
    image: "/products/universal-holders/universal/SH3101401.jpg",
    specifications: {
      "Poles": "14 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "14-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-holder-al-new-model-16p-f",
    name: "Ashok Leyland New Model 16 Pole Female - Special Holder",
    slug: "special-holder-al-new-model-16-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Ashok Leyland new model 16 pole female special holder with 4mm deluxe wire. 9 inch long.",
    partNumber: "SH3101601",
    image: "/products/universal-holders/universal/SH3101601.jpg",
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "16-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-holder-al-new-model-18p-f",
    name: "Ashok Leyland New Model 18 Pole Female - Special Holder",
    slug: "special-holder-al-new-model-18-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Ashok Leyland new model 18 pole female special holder with 4mm deluxe wire. 9 inch long.",
    partNumber: "SH3101801",
    image: "/products/universal-holders/universal/SH3101801.jpg",
    specifications: {
      "Poles": "18 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "18-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-holder-al-new-model-20p-f",
    name: "Ashok Leyland New Model 20 Pole Female - Special Holder",
    slug: "special-holder-al-new-model-20-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Ashok Leyland new model 20 pole female special holder with 4mm deluxe wire. 9 inch long.",
    partNumber: "SH3102001",
    image: "/products/universal-holders/universal/SH3102001.jpg",
    specifications: {
      "Poles": "20 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "20-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-holder-al-new-model-22p-f",
    name: "Ashok Leyland New Model 22 Pole Female - Special Holder",
    slug: "special-holder-al-new-model-22-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Ashok Leyland new model 22 pole female special holder with 4mm deluxe wire. 9 inch long.",
    partNumber: "SH3102201",
    image: "/products/universal-holders/universal/SH3102201.jpg",
    specifications: {
      "Poles": "22 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "22-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-holder-al-new-model-24p-f",
    name: "Ashok Leyland New Model 24 Pole Female - Special Holder",
    slug: "special-holder-al-new-model-24-pole-female",
    category: "Special Holders",
    subcategory: "New Model Holders",
    description: "Ashok Leyland new model 24 pole female special holder with 4mm deluxe wire. 9 inch long.",
    partNumber: "SH3102401",
    image: "/products/universal-holders/universal/SH3102401.jpg",
    specifications: {
      "Poles": "24 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-holder", "24-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
];

// ADDITIONAL RELAY BASE & HEAD LAMP CONNECTORS
export const relayBaseHeadLampAdditionalProducts: Product[] = [
  {
    id: "relay-base-tata-ace-cng-5-4p-f",
    name: "Tata ACE CNG 5+4 Pole Female Relay Base",
    slug: "relay-base-tata-ace-cng-5-4-pole-female",
    category: "Flasher/Relay Base Connectors",
    subcategory: "High Pole Relay Base",
    description: "Tata ACE CNG 5+4 pole female relay base connector with 4mm & 6mm deluxe wire.",
    partNumber: "SH0200951",
    image: "/products/flasher-relay-base/relay-holder/SH0200951.jpg",
    featured: true,
    specifications: {
      "Poles": "5+4 Pole",
      "Gender": "Female",
      "Compatible": "Tata ACE CNG",
      "Wire Type": "4mm & 6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "5-4-pole", "tata", "ace", "cng", "female"],
    applications: ["Tata ACE CNG", "Relay Base"],
  },
  {
    id: "relay-base-universal-10p-f-5mm",
    name: "Universal 10 Pole Female Relay Base - 5mm Wire",
    slug: "relay-base-universal-10-pole-female-5mm",
    category: "Flasher/Relay Base Connectors",
    subcategory: "High Pole Relay Base",
    description: "Universal 10 pole female relay base connector with 5mm deluxe wire.",
    partNumber: "SH0201001",
    image: "/products/flasher-relay-base/relay-holder/SH0201001.jpg",
    specifications: {
      "Poles": "10 Pole",
      "Gender": "Female",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "10-pole", "universal", "female"],
    applications: ["Universal Vehicles", "Relay Base"],
  },
  {
    id: "relay-base-universal-10p-f-5mm-2",
    name: "Universal 10 Pole Female Relay Base - 5mm Wire (Type 2)",
    slug: "relay-base-universal-10-pole-female-5mm-2",
    category: "Flasher/Relay Base Connectors",
    subcategory: "High Pole Relay Base",
    description: "Universal 10 pole female relay base connector with 5mm deluxe wire.",
    partNumber: "SH0201005",
    image: "/products/flasher-relay-base/relay-holder/SH0201005.jpg",
    specifications: {
      "Poles": "10 Pole",
      "Gender": "Female",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "10-pole", "universal", "female"],
    applications: ["Universal Vehicles", "Relay Base"],
  },
  {
    id: "relay-base-tata-fuse-12p-f",
    name: "Tata Fuse 12 Pole Female Base Relay",
    slug: "relay-base-tata-fuse-12-pole-female",
    category: "Flasher/Relay Base Connectors",
    subcategory: "High Pole Relay Base",
    description: "Tata fuse 12 pole female base relay with 4mm & 5mm deluxe wire.",
    partNumber: "SH0201271",
    image: "/products/flasher-relay-base/relay-holder/SH0201271.jpg",
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Compatible": "Tata Fuse",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "12-pole", "tata", "fuse", "female"],
    applications: ["Tata", "Fuse Relay Base"],
  },
  {
    id: "relay-base-al-15p-f",
    name: "Ashok Leyland 15 Pole Female Relay Base",
    slug: "relay-base-al-15-pole-female",
    category: "Flasher/Relay Base Connectors",
    subcategory: "High Pole Relay Base",
    description: "Ashok Leyland 15 pole female relay base connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH0201581",
    image: "/products/flasher-relay-base/relay-holder/SH0201581.jpg",
    specifications: {
      "Poles": "15 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "15-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland", "Relay Base"],
  },
  {
    id: "relay-base-universal-tractor-3w-gc1000-8p-f",
    name: "Universal Tractor/3 Wheelers GC-1000 8 Pole Female",
    slug: "relay-base-universal-tractor-3w-gc1000-8-pole-female",
    category: "Flasher/Relay Base Connectors",
    subcategory: "High Pole Relay Base",
    description: "Universal tractor/3 wheelers GC-1000 8 pole female relay base with 4mm deluxe wire.",
    partNumber: "SH0200801",
    image: "/products/flasher-relay-base/relay-holder/SH0200801.jpg",
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tractor, 3 Wheelers GC-1000",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "8-pole", "tractor", "3-wheeler", "gc-1000", "female"],
    applications: ["Universal Tractor", "3-Wheeler GC-1000"],
  },
  {
    id: "relay-base-sumo-tata-9p-f",
    name: "Universal Relay Base Sumo/Tata 9 Pole Female",
    slug: "relay-base-sumo-tata-9-pole-female",
    category: "Flasher/Relay Base Connectors",
    subcategory: "High Pole Relay Base",
    description: "Universal relay base for Sumo/Tata 9 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH0200901",
    image: "/products/flasher-relay-base/relay-holder/SH0200901.jpg",
    specifications: {
      "Poles": "9 Pole",
      "Gender": "Female",
      "Compatible": "Universal Relay Base - Sumo, Tata",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "9-pole", "sumo", "tata", "female"],
    applications: ["Tata Sumo", "Tata Vehicles", "Relay Base"],
  },
  {
    id: "relay-base-tata-5p-f-5-6mm",
    name: "Universal Relay Tata 5 Pole Female - 5mm & 6mm Wire",
    slug: "relay-base-tata-5-pole-female-5-6mm",
    category: "Flasher/Relay Base Connectors",
    subcategory: "5 Pole Flasher/Relay",
    description: "Universal relay for Tata 5 pole female connector with 5mm & 6mm deluxe wire.",
    partNumber: "SH0200526",
    image: "/products/flasher-relay-base/relay-holder/SH0200526.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Compatible": "Universal Relay Tata",
      "Wire Type": "5mm & 6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "5-pole", "tata", "female"],
    applications: ["Tata Vehicles", "Relay"],
  },
];
